import React from 'react';

const PaymentInfo = ({ amount, foundation, campaign, recurrence }) => {
  return (
    <div className='payment-info'>
      <h2>Información del pago</h2>
      <div className='data'>
        <h4 className='title'>Monto</h4>
        <p className='subtitle'>{amount ? amount : '$0'}</p>
        <h4 className='title'>Fundación</h4>
        <p className='subtitle'>{foundation}</p>
        <h4 className='title'>Tipo</h4>
        <p className='subtitle'>{`Donación ${recurrence}`}</p>
        {campaign && (
          <>
            <h4 className='title'>Campaña</h4>
            <p className='subtitle'>{campaign}</p>
          </>
        )}
      </div>
      <div className='amount'>
        <h4 className='title'>Total</h4>
        <h4 className='subtitle'>{(amount && amount) || '$0'}</h4>
      </div>
    </div>
  );
};

export default PaymentInfo;
